// export const API_URL = "http://localhost:4400";
export const EMAIL_SERVER = "https://vsda-mailer.onrender.com";
export const API_URL = "https://console.vitalskillsda.com";
//

export const DEFUALT_EMAIL_SENDER = "info@vitalskillsda.com";
